module.exports = __webpack_public_path__ + "img/pr-3.6d13c6ce.png";